import type { ReactNode } from "react";
import { Icon } from "../Icon.tsx";
import { classes } from "../classes.ts";
import { KeyHint } from "./KeyHint.tsx";
import styles from "./Button.module.css";

export type ButtonVariant = "primario" | "secundario";

interface Common {
  readonly variant?: ButtonVariant;
  readonly icon?: string;
  readonly kbd?: string;
  readonly children: ReactNode;
}

type Action = Common & {
  readonly onClick?: () => void;
  readonly disabled?: boolean;
  readonly type?: "button" | "submit";
  readonly href?: never;
  readonly "data-atalho"?: string;
};
type Link = Common & { readonly href: string };

export function Button(props: Action | Link) {
  const { variant = "secundario", icon, kbd, children } = props;
  const inner = (
    <>
      {icon === undefined ? null : <Icon svg={icon} size={24} className={styles.icon} />}
      <span>{children}</span>
      {kbd === undefined ? null : <KeyHint onInk={variant === "primario"}>{kbd}</KeyHint>}
    </>
  );
  const className = classes(styles.button, styles[variant], icon !== undefined && styles.withIcon);
  if ("href" in props && props.href !== undefined) {
    return (
      <a className={className} href={props.href}>
        {inner}
      </a>
    );
  }
  return (
    <button type={props.type ?? "button"} className={className} onClick={props.onClick} disabled={props.disabled} data-atalho={props["data-atalho"]}>
      {inner}
    </button>
  );
}

export function Buttons({ children }: { readonly children: ReactNode }) {
  return <div className={styles.row}>{children}</div>;
}
